(function() {
window.addEventListener('DOMContentLoaded', function() {
    if (window.innerWidth > 576) { // Check if screen size is greater than 576px
        var maxHeight = 0;
        var elements = document.querySelectorAll('#SecondEvents .event-content-text');

        elements.forEach(function(element) {
            var thisHeight = element.offsetHeight;
            if (thisHeight > maxHeight) {
                maxHeight = thisHeight;
            }
        });

        elements.forEach(function(element) {
            element.style.height = maxHeight + 'px';
        });
    }
});

var isAlreadyUpdated = false;
document.addEventListener('DOMContentLoaded', function () {
    const eventItems = document.querySelectorAll('.event-itemforAnimation');
    const loadSection = document.querySelector('.load-section');

    // If .load-section is NOT present → show all items and exit
    if (!loadSection) {
        eventItems.forEach(item => {
            item.style.display = "block";
        });
        return;
    }

    const itemsPerLoadEl = document.getElementById("hdnNumberOfItems");
    const loadMoreBtn = document.getElementById('load-more');
    const progressBar = document.getElementById('progress-bar');
    const infoText = document.getElementById('info-text');
    //const remainingSpan = document.getElementById('eventLoadMore');

    if (!itemsPerLoadEl || !loadMoreBtn || !progressBar || !infoText || eventItems.length === 0) {
        console.error("One or more required elements are missing in the DOM.");
        return;
    }

    const itemsPerLoad = parseInt(itemsPerLoadEl.value, 10);
    const totalItems = eventItems.length;
    let currentIndex = 0;
    let infoTextTemplate = infoText.innerHTML;


    function updateUI() {
        const previousLastIndex = currentIndex - 1;
        for (let i = currentIndex; i < currentIndex + itemsPerLoad && i < totalItems; i++) {
            eventItems[i].style.display = 'block';
        }

        currentIndex += itemsPerLoad;

        const percentage = (currentIndex / totalItems) * 100;
        progressBar.style.width = `${Math.min(percentage, 100)}%`;

        const shown = Math.min(currentIndex, totalItems);
        const remaining = totalItems - shown;
        //infoText.textContent = `Showing ${shown} of ${totalItems}`;
        if (!isAlreadyUpdated) {
            let infoTextContent = infoTextTemplate;
            infoText.textContent = infoTextContent
                .replace("{0}", shown)
                .replace("{1}", totalItems);
            isAlreadyUpdated = true;
        }
        //remainingSpan.textContent = remaining;
        // Move focus to next sibling anchor after last visible event item
        if (previousLastIndex >= 0 && eventItems[previousLastIndex]) {
            const sibling = eventItems[previousLastIndex].nextElementSibling;
            if (sibling) {
                const nextAnchor = sibling.matches("a")
                    ? sibling
                    : sibling.querySelector("a");

                if (nextAnchor) {
                    nextAnchor.focus({ preventScroll: false });
                }
            }
        }
        if (currentIndex >= totalItems) {
            loadMoreBtn.style.display = 'none';
        }
        setTimeout(() => {
            isAlreadyUpdated = false;
        }, 300);
    }

    updateUI();
    loadMoreBtn.addEventListener('click', updateUI);
});

})();
